import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { useEffect, useState } from 'react'

import { IconButton } from 'components/ui/Button/IconButton/IconButton'
import { Slider } from 'components/ui/Slider/Slider'
import { Button } from 'components/ui/Button/Button'
import { dateFormat } from 'utils/dateformat'

export interface IntervalFilterProps {
  onSelect?: (value: [Date, Date]) => void
  values?: [Date, Date]
}

export const IntervalFilter: React.FC<IntervalFilterProps> = ({
  values = [null, null],
  onSelect,
}: IntervalFilterProps) => {
  const [isActive, setIsActive] = useState<boolean>(false)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [text, setText] = useState<string>('')

  useEffect(() => {
    const [from, to] = values

    if (!from || !to) return

    setStartDate(from)
    setEndDate(to)
  }, [values])

  useEffect(() => {
    const [from, to] = values

    if (!from || !to) {
      setText('Дата')
      return
    }

    setText(`${dateFormat(from, 'DD/MM')} - ${dateFormat(to, 'DD/MM')}`)
  }, [values])

  const handleOnChange = (dates: Date[]) => {
    const [start, end] = dates
    setStartDate(start)
    setEndDate(end)
  }

  const handleOnSubmit = () => setIsActive(true)

  const handleOnFilterSubmit = () => {
    setIsActive(false)
    onSelect?.([startDate, endDate])
  }

  const handleOnFilterClose = () => {
    setIsActive(false)

    const [from, to] = values
    setStartDate(from)
    setEndDate(to)
  }

  return (
    <>
      <IconButton title={text} icon="arrow" outline round onSubmit={handleOnSubmit}></IconButton>
      <Slider isActive={isActive} onClose={handleOnFilterClose} height="450px">
        <div className="filter-wheel__slider">
          <h2>Фильтр по интервалу</h2>
          <div className="filter-wheel__slider-items" style={{ alignSelf: 'center' }}>
            <DatePicker
              selected={startDate}
              onChange={handleOnChange}
              startDate={startDate}
              endDate={endDate}
              dateFormat="yyyy-MM-dd"
              selectsRange
              inline
            />
          </div>
          <div className="filter-wheel__slider_controlls flex-center">
            <span style={{ marginRight: '0.5rem' }}>
              <Button title="Применить" handleOnSubmit={handleOnFilterSubmit}></Button>
            </span>
            <Button title="Отменить" outline handleOnSubmit={handleOnFilterClose}></Button>
          </div>
        </div>
      </Slider>
    </>
  )
}
